import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { BisaNavConfig } from "app/components/app-common-views/bisa-nav-container/sidebar-nav/nav-menus.constants";
import { buildAclList } from "app/components/app-common-views/sidebar-nav/menus.utils";
import { NavConfig } from "app/components/app-common-views/sidebar-nav/nav-menus.constants";
import { SetSelectedPrimaryNavConfig } from "app/store/sidebar/sidebar.actions";
import { Observable } from "rxjs";
import { take } from "rxjs/operators";
import { LABELS } from "shared/consts/labels.const";
import { RolesService } from "shared/services/roles.service";
import { SidebarService } from "shared/services/sidebar.service";
import { Store } from '@ngrx/store';
import { IAppState } from 'app/store/app/app.state';

export interface ActiveNavMenuIds {
    primary: string | null;
    secondary: string | null;
    tertiary: string | null;
}

/**
 * Finds the active nav menu IDs (primary, secondary, tertiary) for a given route.
 */
export function getActiveNavMenuIds(
    navConfigs: BisaNavConfig[],
    activeRoute: string,
    routeIsActive: (expectedRoute: string, actualRoute: string) => boolean
): ActiveNavMenuIds {
    let activePrimaryRoute: string | null = null;
    let activeSecondaryRoute: string | null = null;
    let activeTertiaryRoute: string | null = null;

    navConfigs.forEach(primaryMenuConfig => {
        // Check primary route
        if (
            primaryMenuConfig.route &&
            routeIsActive(primaryMenuConfig.route, activeRoute)
        ) {
            activePrimaryRoute = primaryMenuConfig.id;
            activeSecondaryRoute = null;
            activeTertiaryRoute = null;
        }

        // Check secondary routes
        if (Array.isArray(primaryMenuConfig.subMenuItems)) {
            primaryMenuConfig.subMenuItems.forEach(secondaryMenuConfig => {
                if (
                    secondaryMenuConfig.route &&
                    routeIsActive(secondaryMenuConfig.route, activeRoute)
                ) {
                    activePrimaryRoute = primaryMenuConfig.id;
                    activeSecondaryRoute = secondaryMenuConfig.id;
                    activeTertiaryRoute = null;
                }

                // Check tertiary routes
                if (Array.isArray(secondaryMenuConfig.subMenuItems)) {
                    secondaryMenuConfig.subMenuItems.forEach(tertiaryMenuConfig => {
                        if (
                            tertiaryMenuConfig.route &&
                            routeIsActive(tertiaryMenuConfig.route, activeRoute)
                        ) {
                            activePrimaryRoute = primaryMenuConfig.id;
                            activeSecondaryRoute = secondaryMenuConfig.id;
                            activeTertiaryRoute = tertiaryMenuConfig.id;
                        }
                    });
                }
            });
        }
    });

    return {
        primary: activePrimaryRoute,
        secondary: activeSecondaryRoute,
        tertiary: activeTertiaryRoute,
    };
}

export function routeIsActive(expectedRoute: string, actualRoute: string): boolean {
    if (!expectedRoute || !actualRoute)
        return false;

    return (
        expectedRoute &&
        actualRoute &&
        (actualRoute.startsWith(expectedRoute) ||
            (expectedRoute.endsWith('/') && actualRoute.startsWith(expectedRoute.slice(0, -1))))
    );
}

export function buildMenuGuard(menuConfig: NavConfig,
    menuGuards: { [name: string]: Observable<boolean> },
    rolesService: RolesService) {
    if (!menuConfig.subMenuItems) return;

    menuConfig.subMenuItems.forEach(subMenuConfig => {
        menuGuards[subMenuConfig.id] = rolesService
            .hasResourceAccess(buildAclList(subMenuConfig))
            .pipe(take(1));
        buildMenuGuard(subMenuConfig, menuGuards, rolesService);
    });
}

export function triggerSideNavItemSubMenu(e, sharedService: SidebarService,
    isAccessPage: boolean, menuItemType: string, globalConfig: BisaNavConfig,
    _router: Router, _store: Store<IAppState>, config?: string): void {
    sharedService.isAccessPage(isAccessPage);
    if (!isAccessPage && menuItemType === LABELS.MENU_TYPE_MAIN) {
        return
    }
    else if (config && globalConfig?.route)
        _router.navigate([globalConfig.route]);

    if (e) {
        e.stopPropagation();
        _store.dispatch(new SetSelectedPrimaryNavConfig(globalConfig));
    } else {
        _store.dispatch(new SetSelectedPrimaryNavConfig(null));
    }
}